import React from 'react'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'

const IconWaring = (): any => {
  return <WarningAmberOutlinedIcon className='onerem' style={{ fill: 'rgb(236 154 37)', fontSize: '20px' }} />
}

export default IconWaring
